const Layout = ({ children, bgCuadro }) => {
  return <div className="cuadro" style={{backgroundColor: bgCuadro}}>{children}</div>;
};
export default Layout;
